'use strict';

var React = require('react');

var SvgLanguageMinor = function SvgLanguageMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m11.428 13.999 1.572-3.538 1.573 3.538zm6.486 2.594-4-9a1 1 0 0 0-1.828 0l-1.958 4.406h-.128c-1.276 0-2.24-.3-2.965-.716l.012-.012c1.292-1.443 1.777-3.536 1.94-5.272h1.013a1 1 0 1 0 0-2h-.942c-.015-.63-.058-1.051-.064-1.11a.998.998 0 0 0-1.103-.884 1.002 1.002 0 0 0-.885 1.103c0 .013.035.359.05.89h-4.056a1 1 0 0 0 0 2h3.98c-.143 1.37-.515 2.922-1.42 3.935a4.165 4.165 0 0 1-.591-1.183.999.999 0 0 0-1.938.492c.118.474.373 1.07.778 1.679-.254.05-.522.078-.81.078a1 1 0 0 0 0 2c.857 0 1.629-.16 2.322-.467.962.734 2.253 1.303 3.932 1.435l-1.167 2.626a1.001 1.001 0 0 0 1.828.812l.625-1.406h4.922l.625 1.406a1 1 0 0 0 1.828-.812z"
  }));
};

exports.SvgLanguageMinor = SvgLanguageMinor;
